export const rootElementId = 'roblox-credit-container';

export const translation = {
  common: ['CommonUI.Controls'],
  feature: 'Feature.RobloxCredit'
};
